// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__zh_3d","rightAdornment":"Header_rightAdornment__1Tr7r"};